import * as types from '../../../actions/actiontypes';

import initialState from '../../initialstate';

export function bulkRequestSearchReducer(state = initialState.bulkRequestSearchOptions, action) {
	switch (action.type) {
		case types.SET_BULK_REQUEST_SEARCH:
			return {
				...state,
				searchTerm: action.searchTerm
			};
		default:
			return state;
	}
}
